import {Component} from '@angular/core';
import {AlertController, Keyboard, NavController} from 'ionic-angular';
import {StoreService} from "../../services/StoreService";
import {AuthService} from "../../services/AuthService";
import {Retailer} from "../../model/Store";
import {OperationService} from "../../services/OperationService";
import {PhotoService} from "../../services/PhotoService";
import {DateService} from "../../services/DateService";
import {MissionReportPhoto} from "../../model/MissionReportPhoto";
import {apiconfig} from "../../app/api.config";
import {OperationCard} from "../../model/OperationCard";
import {OperationCustomerPlanningSetting} from "../../model/Operation";

/**
 * Generated class for the GalleryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


export class StorePictureStrip {
  storeName: string;
  pictures: MissionReportPhoto[] = [];
  retailerCode: string;

  add(ph: MissionReportPhoto) {
    if (ph.urlPicture == null) return;
    this.pictures.push(ph);

    if (this.retailerCode == null)
      this.retailerCode = ph.retailerCode;
  }
}

export class OperationPictureAlbum {
  operation: OperationCard;
  storeStrips: StorePictureStrip[] = [];

  findOrCreateStoreString(storeName: string) {
    for (let i = 0; i < this.storeStrips.length; i++)
      if (this.storeStrips[i].storeName === storeName) return this.storeStrips[i];

    let s = new StorePictureStrip();
    this.storeStrips.push(s);
    s.storeName = storeName;
    return s;
  }
}

export class FeaturedPhoto {
  operation: OperationCard;
  strip: StorePictureStrip;
  photo: MissionReportPhoto;

  setup(operation: OperationCard, strip: StorePictureStrip, photo: MissionReportPhoto): FeaturedPhoto {
    this.operation = operation;
    this.strip = strip;
    this.photo = photo;
    return this;
  }

}

@Component({
  selector: 'page-gallery',
  templateUrl: 'gallery.html',
})
export class GalleryPage {

  //spinner
  loadingComplete: boolean = false;

  inputRet: string = '';
  inputOp: string = '';

  uiShowFilters: boolean;

  /**
   * the photo we want to feature in the lightbox
   */
  uiFeaturedPhoto: FeaturedPhoto;

  public iconsURL: string = apiconfig.LOGA_ICONS;

  retailers: Retailer[];
  retailersFound: Retailer[];

  from: string;
  to: string;

  searchRet: number;


  photoAlbums: OperationPictureAlbum[] = null;

  operations: OperationCard[];
  matchinOperations: OperationCard[];
  currentlyLoadingOp: OperationCard;


  constructor(public navCtrl: NavController,
              public alertCtrl: AlertController,
              public storeService: StoreService,
              public photoService: PhotoService,
              public dateService: DateService,
              public operationService: OperationService,
              public authService: AuthService,
              private keyboard: Keyboard) {
  }


  ionViewWillEnter() {

    this.uiShowFilters = false;

    this.storeService.loadRetailers().then(
      (response) => {

        this.retailers = response;
        // add at the beginning
        this.retailers.unshift(new Retailer());

        let now: Date = new Date();
        now.setMonth(now.getMonth() - 1);
        this.from = now.toISOString();

        now.setMonth(now.getMonth() + 1);
        this.to = now.toISOString();

        this.operations = [];
        this.operationService.loadOperationCards()
          .then(response => {
            this.operations = response;
            this.loadingComplete = true;
            this.uiShowFilters = true;
          });

      }).catch(err => {
      console.log("Could not load reatailer - check API");
    });
  }


  /**
   * Retailer autocomplete process
   * @param selectRetailer
   */
  addRet(selectRetailer: Retailer) {
    this.inputRet = selectRetailer.name;
    this.retailersFound = [];

    this.searchRet = selectRetailer.id;
  }

  removeFocus() {
    this.keyboard.close();
  }

  searchRetailer() {
    if (!this.inputRet.length || !this.keyboard.isOpen()) {
      this.retailersFound = [];
      return;
    }
    this.retailersFound = this.retailers.filter(item => item.name !== undefined && item.name.toUpperCase().includes(this.inputRet.toUpperCase()));
  }

  addOp(selectOperation: OperationCard) {
    selectOperation.toggleSelected();
  }

  searchOperation() {
    this.matchinOperations = [];
    if (this.operations != null) {
      this.operations.forEach(op => {
        if (op.name.toUpperCase().includes(this.inputOp.toUpperCase()))
          this.matchinOperations.push(op);
      })
    }
  }

  toggleShowFilters() {
    this.uiShowFilters = !this.uiShowFilters;
  }


  /***
   *
   */
  search() {
    console.log("search pictures")
    if (this.from == null || this.to == null) {

      let alert = this.alertCtrl.create({
        title: 'Erreur',
        message: ' Merci de saisir une période de recherche !',
        buttons: ['Fermer'],
        cssClass: 'alertDanger'
      });
      alert.present();


    } else {
      let atLeastOne = false;

      this.photoAlbums = [];
      this.uiShowFilters = false;
      this.loadingComplete = false;

      let allP = [];

      this.operations.forEach(op => {
        if (op.uiSelected) {
          allP.push(this.loadOperationPhoto(op));
          atLeastOne = true;
        }
      });

      if (!atLeastOne) {
        this.operations.forEach(op => {
          allP.push(this.loadOperationPhoto(op));
        });
      }

      Promise.all(allP).then(any => {
        this.loadingComplete = true;
        this.currentlyLoadingOp = null;
      });

    }
  }

  /**
   *
   * @param op
   */
  private loadOperationPhoto(op: OperationCard): Promise<any> {


    this.currentlyLoadingOp = op;

    return this.photoService.searchPhoto(this.dateService.dateToEpochDay(new Date(this.from)), this.dateService.dateToEpochDay(new Date(this.to)),
      op.id, this.searchRet, null).then((photoReport) => {

        this.loadingComplete = false;

        if (photoReport == null || photoReport.length == 0) {

        } else {

          let animaToken: string;
          let logaToken: string = this.authService.buildLogaToken();


          // TODO : A mon avis il faut faire le filtre coté serveur.
          let customerPlanningSetting: OperationCustomerPlanningSetting;

          // load settings and filtering pictures
          return this.operationService.loadOperationCustomerPlanningSettings(op.id)
            .then((response) => {
              customerPlanningSetting = response;

              /// keep only my own operations (Operations with a quotas hours is defined for me)
              photoReport = photoReport.filter((ph) => this.filterPhoto(op, customerPlanningSetting, ph));

              photoReport.forEach((ph) => {

                switch (ph.source) {
                  case "PCHECK":
                    logaToken = this.authService.buildLogaToken();
                    ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                    ph.urlThumbnail = ph.urlThumbnail + "&jtkn=" + logaToken;
                    break;
                  case "COACHING":
                    logaToken = this.authService.buildLogaToken();
                    ph.urlPicture = ph.urlPicture + "&jtkn=" + logaToken;
                    ph.urlThumbnail = ph.urlThumbnail + "&jtkn=" + logaToken;
                    break;
                  case "ANIMA_TAG_PHOTO":
                    animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                    ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                    ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                    break;
                  case "ANIMA_ISA_PHOTO":
                    animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                    ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                    ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                    break;
                  case "ANIMA_PRODUCT_PHOTO":
                    animaToken = this.authService.buildAnimaInputFieldToken(ph.logaWorkDayId);
                    ph.urlPicture = ph.urlPicture + "&tkn=" + animaToken;
                    ph.urlThumbnail = ph.urlThumbnail + "&tkn=" + animaToken;
                    break;
                  default:
                    console.log("Unknown source:" + ph.source)
                    break;
                }

              });

              photoReport = photoReport.filter(ph => ph.urlPicture != null);

              photoReport.forEach(ph => {

                // -- find / create album
                let albums = this.photoAlbums.filter(a => a.operation.id == ph.operationId);
                let album = albums.length > 0 ? albums[0] : null;
                if (album == null) {
                  album = new OperationPictureAlbum();
                  album.operation = op;
                  this.photoAlbums.push(album);
                }

                let strip: StorePictureStrip = album.findOrCreateStoreString(ph.storeName);
                strip.add(ph);

              });

              this.loadingComplete = true;

            });
        }

      }
    );
  }

  private filterPhoto(op: OperationCard, customerPlanningSetting: OperationCustomerPlanningSetting, ph: MissionReportPhoto) {
    if (op.id === ph.operationId) {

      switch (ph.source) {
        case "PCHECK":
        case "COACHING":
          if ('YES' === customerPlanningSetting.showCheckInQuestionnaire) {
            return true;
          } else if ('PUBLISHED' === customerPlanningSetting.showCheckInQuestionnaire) {
            return ph.published;
          }
          return false;
        case "ANIMA_TAG_PHOTO":
        case "ANIMA_ISA_PHOTO":
        case "ANIMA_PRODUCT_PHOTO":
          if ('YES' === customerPlanningSetting.showCra) {
            return true;
          } else if ('PUBLISHED' === customerPlanningSetting.showCra) {
            return ph.published;
          } else
            return false;
        default:
          break;
      }
    }

    return false;
  }

  hideOpeListing() {
    this.matchinOperations = [];
  }

  displayPictureLightBox(album: OperationPictureAlbum, strip: StorePictureStrip, photo: MissionReportPhoto) {
    this.uiFeaturedPhoto = photo == null ? null : new FeaturedPhoto().setup(album.operation, strip, photo);
  }

  downloadPicture(uiFeaturedPhoto: FeaturedPhoto) {

  }
}





// WEBPACK FOOTER //
// ./src/pages/gallery/gallery.ts